import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    0% {\n      opacity: 1;\n      padding-top: ", ";\n      padding-bottom:  ", ";\n    }\n    100% {\n      opacity: 0;\n      height: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n    }"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    0% {\n      opacity: 0;\n      height: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n    100% {\n      opacity: 1;\n      padding-top: ", ";\n      padding-bottom: ", ";\n    }"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { Notification as CoreNotification } from '@vds-core/notifications';
import { BodyConfig } from '@vds-core/typography';
import { colors, calculateSpacing } from '@vds-core/theme';
import { IconData } from '@vds-core/icons';

var _calculateAnimateIn = function _calculateAnimateIn(containerHeight, viewport) {
  return keyframes(_templateObject(), calculateSpacing('5X', 'rem'), calculateSpacing('5X', 'rem'));
};

var _calculateAnimateOut = function _calculateAnimateOut(containerHeight, viewport) {
  return keyframes(_templateObject2(), calculateSpacing('5X', 'rem'), calculateSpacing('5X', 'rem'));
};

var Notification = function Notification(props) {
  var viewport = props.viewport;
  var animProperties = '0.35s cubic-bezier(0.22, 0.61, 0.36, 1) .5s normal 1 both';

  function _calculateContentColor(alertType, type, color) {
    if (alertType === 'warning' || type === 'warning' || alertType === 'error' || type === 'error') {
      return colors.textColorWarning;
    } else {
      return colors.white;
    }
  }

  return /*#__PURE__*/React.createElement(CoreNotification, _extends({}, props, {
    focusState: false,
    activeState: false,
    hasViewport: false,
    showNotificationIcon: false,
    color: colors,
    viewport: viewport,
    title: null,
    subtitle: null,
    iconConfig: IconData,
    bodyConfig: BodyConfig,
    animateIn: _calculateAnimateIn,
    animateOut: _calculateAnimateOut,
    animationProperties: animProperties,
    fullBleed: false,
    hitArea: false,
    contentColor: _calculateContentColor,
    minWidth: "288px",
    maxWidth: "1272px",
    unMountTime: 400
  }));
};

export default Notification;